// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopTwoToneSvg from "@fishx/icons-svg/es/asn/ShopTwoTone";
import FishxIcon from '../components/FishxIcon';

var ShopTwoTone = function ShopTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopTwoToneSvg
  }));
};

ShopTwoTone.displayName = 'ShopTwoTone';
export default React.forwardRef(ShopTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShopTwoTone.js
// module id = 4101
// module chunks = 0